import { getAPI } from "../../../api/Networking";
import { JobRecord } from "../../../models/Jobs/JobRecord";
import { PaginatedAPIResponse } from "../../../models/NetworkResponse";
import { JobAPIFilters } from "../../../models/Jobs/JobFilters";

export default class JobAPI {
  getJobs = async (
    filters: JobAPIFilters
  ): Promise<PaginatedAPIResponse<JobRecord>> => {
    try {
      const queryParams = new URLSearchParams();
      if (filters.page_no)
        queryParams.append("page_no", filters.page_no.toString());
      if (filters.limit) queryParams.append("limit", filters.limit.toString());
      if (filters.sort_by) queryParams.append("sort_by", filters.sort_by);
      if (filters.sort_type)
        queryParams.append("sort_type", filters.sort_type.toString());
      if (filters.name) queryParams.append("name", filters.name);
      if (filters.max_progress)
        queryParams.append("max_progress", filters.max_progress.toString());
      if (filters.progress)
        queryParams.append("progress", filters.progress.toString());
      if (filters.admin_id)
        if (Array.isArray(filters.admin_id))
          queryParams.append(
            "admin_id",
            filters.admin_id.map((item) => item.id).join(",")
          );
        else queryParams.append("admin_id", filters.admin_id.id.toString());
      const response = await getAPI(`/v5/jobs?${queryParams.toString()}`);
      return response.result;
    } catch (error) {
      throw error;
    }
  };
}
